enum Breakpoint {
    XL = 'xl',
    LG = 'lg',
    MD = 'md',
    SM = 'sm',
    XS = 'xs',
}

export default Breakpoint;
